import { Button, Typography } from '@mui/material'
import BackButton from '../../buttons/BackButton'
import CardTAG from '../../CardTAG'
import TextInput from '../../TextInput'
import FormLayout from '../FormLayout'
import { IForgotPasswordForm } from './types'
const ForgotPasswordForm: React.FC<IForgotPasswordForm> = ({ register, emailError = '' }) => {
  return (
    <CardTAG title='Forgot your password?'>
      <Typography variant='bodyRegular' sx={{ marginBottom: '2.8rem' }}>
        Enter the email associated with your account and we’ll send an email with instructions to
        reset your password.
      </Typography>
      <FormLayout>
        <TextInput label='Email' register={register} fieldName='email' error={emailError} />
        <Button variant='submitFormButton' type='submit'>
          <Typography variant='bodyBold'>Send Instructions</Typography>
        </Button>
        <BackButton href='login' btnText='Back To Log In' />
      </FormLayout>
    </CardTAG>
  )
}

export default ForgotPasswordForm
